import Card32new from "../../assets/images/32card.png";
export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;
const CATEGORY_TYPE = {
  MOST_POPULAR: "popular",
  NEWEST: "newest",
};
export const casinoTabs = {
  LiveDealer: {
    
    AutoRoulettePL: {
      href: "/casino/aggapezugi-automatic-roulette",
      code: "1000149",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/autoroulette.jpg", alt: "" },
      name: "Auto Roulette",
      providerName: "Ezugi",
    },
    CrazyTimePL: {
      href: "/casino/ezgevo-crazy-time",
      code: "1000149",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/crazytime.jpg", alt: "" },
      name: "Crazy Time",
      providerName: "Evolution",
    },
    AviatorPL: {
      href: "/casino/aggapspribe-aviator",
      code: "1000149",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/Aviator.webp", alt: "" },
      name: "Aviator",
      providerName: "Spribe",
    },
    SpeedRoulette1PL: {
      href: "/casino/aggapezugi-speed-roulette",
      code: "1000149",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/Speedroulette.webp", alt: "" },
      name: "Aviator",
      providerName: "Ezugi",
    },
    DragonTiger1PL: {
      href: "/casino/aggapezugi-dragon-tiger",
      code: "1000149",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/Dragontigerr.webp", alt: "" },
      name: "Dragon Tiger",
      providerName: "Ezugi",
    },
    UltimateRoulettePL: {
      href: "/casino/aggapezugi-ultimate-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/UltimateRoulette.webp", alt: "" },
      name: "Ultimate Roulette",
      providerName: "Ezugi",
    },
    FootballStudioPL: {
      href: "/casino/ezgevo-football-studio",
      code: "1000149",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/FootballStudio.webp", alt: "" },
      name: "FootballStudio",
      providerName: "Evolution",
    },
    DreamCatcherPL: {
      href: "/casino/ezgevo-dream-catcher",
      code: "1000149",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/dreamcatcher.webp", alt: "" },
      name: "Dream Catcher",
      providerName: "Evolution",
    },
    TwinSpinPL: {
      href: "/casino/ezgne-twin-spin-megaways",
      code: "1000149",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/TwinSpinmegaways.webp", alt: "" },
      name: "Twin Spin",
      providerName: "Slote",
    },
    CashVoltPL: {
      href: "/casino/ezgrt-cash-volt",
      code: "1000149",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/Cashvolt.webp", alt: "" },
      name: "Cash Volt",
      providerName: "Slots",
    },
    DazzleMemegawaysPL: {
      href: "/casino/ezgne-dazzle-me-megaways",
      code: "1000149",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/DazzleMemegaways.webp", alt: "" },
      name: "Dazzle Memegaways",
      providerName: "Slots",
    },
    AlohaChristmasPL: {
      href: "/casino/ezgne-aloha-christmas",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/AlohaChristmas.webp", alt: "" },
      name: "Aloha Christmas",
      providerName: "Slots",
    },
    BloodSuckersPL: {
      href: "/casino/ezgne-blood-suckers",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/BloodSuckers.webp", alt: "" },
      name: "Blood Suckers",
      providerName: "Slots",
    },
    ButterflyStaxxPL: {
      href: "/casino/ezgne-butterfly-staxx",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/ButterflyStaxx.webp", alt: "" },
      name: "Butterfly Staxx",
      providerName: "Slots",
    },
    GonzosTreasureHuntPL: {
      href: "/casino/ezgne-gonzos-treasure-hunt",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/GonzosTreasureHunt.webp", alt: "" },
      name: "Gonzos Treasure Hunt",
      providerName: "Slots",
    },
    PiggyRichesPL: {
      href: "/casino/ezgne-piggy-riches",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/PiggyRiches.webp", alt: "" },
      name: "Piggy Riches",
      providerName: "Slots",
    },
    SteamTowerPL: {
      href: "/casino/ezgne-steam-tower",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/SteamTower.webp", alt: "" },
      name: "Steam Tower",
      providerName: "Slots",
    },
    TwinSpinMegaways: {
      href: "/casino/ezgne-twin-spin-megaways",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: { src: "./images/dealer/TwinSpinmegaways.webp", alt: "" },
      name: "Twin Spin Megaways",
      providerName: "Slots",
    },
  },

  PopularGames: {
    // CrazyBallsLD: {
    //   href: "/casino/qtechevolutiongaming-crazy-balls",
    //   code: "",
    //   casino: "QTECH",
    //   provider: "",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   cover: {
    //     src: "./images/popular/new/crazy-balls.webp",
    //     alt: "crazy balls",
    //   },
    //   name: "Crazy Balls",
    //   providerName: "Evolution",
    // },
    CrazyTimeLD: {
      href: "/casino/ezgevo-crazy-time",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: {
        src: "./images/popular/new/crazy-time.webp",
        alt: "crazy time",
      },
      name: "Crazy Time",
      providerName: "Evolution",
    },
    CricketWarLD: {
      href: "/casino/aggapezugi-cricket-war",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: {
        src: "./images/popular/new/cricket-war.webp",
        alt: "cricket war",
      },
      name: "Cricket War",
      providerName: "Evolution",
    },
    // DiceDuelLD: {
    //   href: "/casino/qt-dice-duel",
    //   code: "",
    //   casino: "Qtech",
    //   provider: "WorldCasino",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   cover: {
    //     src: "./images/popular/new/dice-duel.webp",
    //     alt: "dice duel",
    //   },
    //   name: "Dice Duel",
    //   providerName: "Qtech",
    // },
    FanTanLD: {
      href: "/casino/km-fan-tvan-classic",
      code: "",
      casino: "Kingmaker",
      provider: "Kingmaker",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: {
        src: "./images/popular/new/fan-tan.webp",
        alt: "fan tan",
      },
      name: "Fan Tan",
      providerName: "Kingmaker",
    },
    FunkyTimeLD: {
      href: "/casino/ezgevo-funky-time",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: {
        src: "./images/popular/new/funky-time.webp",
        alt: "funky time",
      },
      name: "Funky Time",
      providerName: "Evolution",
    },
    LighteningDragonTigerLD: {
      href: "/casino/ezgevo-lightening-dragon-tiger",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: {
        src: "./images/popular/new/lightenin-dragon-tiger.webp",
        alt: "lightenin dragon tiger",
      },
      name: "Lightenin Dragon Tiger",
      providerName: "Evolution",
    },
    LightningBlackjackLD: {
      href: "/casino/ezgevo-lightning-blackjack",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: {
        src: "./images/popular/new/lightning-blackjack.webp",
        alt: "lightning blackjack",
      },
      name: "Lightning Blackjack",
      providerName: "Evolution",
    },
    LightningStormLD: {
      href: "/casino/ezgevo-gonzos-lightning-storm",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: {
        src: "./images/popular/new/lightning-storm.webp",
        alt: "lightning storm",
      },
      name: "Lightning Storm",
      providerName: "Evolution",
    },
    PowerBlackjackLD: {
      href: "/casino/ezgevo-power-blackjack",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: {
        src: "./images/popular/new/power-blackjack.webp",
        alt: "power blackjack",
      },
      name: "Power Blackjack",
      providerName: "Evolution",
    },
    // SuperAndarBaharLD: {
    //   href: "/casino/qtechevolutiongaming-super-andar-bahar",
    //   code: "",
    //   casino: "Evolution",
    //   provider: "Ezugi",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   cover: {
    //     src: "./images/popular/new/super-andar-bahar.webp",
    //     alt: "super andar bahar",
    //   },
    //   name: "Super Andar Bahar",
    //   providerName: "Evolution",
    // },
    SuperSicBboLD: {
      href: "/casino/ezgevo-super-sic-bo",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: {
        src: "./images/popular/new/super-sic-bo.webp",
        alt: "super sic bo",
      },
      name: "Super Sic Bo",
      providerName: "Evolution",
    },
    // SweetBonanzaCandyLandLD: {
    //   href: "/casino/qt-sweet-bonanza-candy-land",
    //   code: "",
    //   casino: "Qtech",
    //   provider: "WorldCasino",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   cover: {
    //     src: "./images/popular/new/sweet-bonanza-candy-land.webp",
    //     alt: "sweet bonanza candy land",
    //   },
    //   name: "Sweet Bonanza Candy Land",
    //   providerName: "Qtech",
    // },
    XXXtremeLightningRouletteLD: {
      href: "/casino/ezgevo-xxxtreme-lightning-roulette",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/Casino"),
      cover: {
        src: "./images/popular/new/xxxtreme-lightning-oulette.webp",
        alt: "xxxtreme lightning oulette",
      },
      name: "XXXtreme Lightning Roulette",
      providerName: "Evolution",
    },

    
  },

  Slots: {
    twinspin: {
      href: "/casino/ezugi/twinspin",
      code: "1100039",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/ezugi-slots/twinspin.png", alt: "" },
    },
    gonzoquest: {
      href: "/casino/ezugi/gonzoquest",
      code: "1100018",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/slots/ezugi-slots/gonzo.png",
        alt: "",
      },
    },

    asgardianstones: {
      href: "/casino/ezugi/asgardianstones",
      code: "1100096",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/ezugi-slots/stones.png", alt: "" },
    },
    secrets: {
      href: "/casino/ezugi/secrets",
      code: "1100106",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/ezugi-slots/secrets.png", alt: "" },
    },
    grandwheel: {
      href: "/casino/ezugi/grandwheel",
      code: "1100150",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/ezugi-slots/wheel.png", alt: "" },
    },
    Strike777: {
      href: "/casino/ezugi/Strike777",
      code: "1100031",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/ezugi-slots/777_Strike.png", alt: "" },
    },
    Nights1000: {
      href: "/casino/ezugi/Nights1000",
      code: "1100003",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/ezugi-slots/10001Nights.png", alt: "" },
    },
    CashUltimate: {
      href: "/casino/ezugi/CashUltimate",
      code: "1100070",
      casino: " ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/Cash_Ultimate.png", alt: "" },
    },
    CashVolt: {
      href: "/casino/ezugi/CashVolt",
      code: "1100071",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/ezugi-slots/Cash_Volt.png", alt: "" },
    },
    DazzleMegaways: {
      href: "/casino/ezugi/DazzleMegaways",
      code: "1100083",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/slots/ezugi-slots/Dazzle_Me_Megaways.png",
        alt: "",
      },
    },
    DivinieFortuneMegaways: {
      href: "/casino/ezugi/DivinieFortuneMegaways",
      code: "1100089",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/slots/ezugi-slots/Divine_Fortune_Megaways.png",
        alt: "",
      },
    },
    Dynamiteriches: {
      href: "/casino/ezugi/Dynamiteriches",
      code: "1100073",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/ezugi-slots/FortuneHouse.png", alt: "" },
    },
    FortuneHouse: {
      href: "/casino/ezugi/FortuneHouse",
      code: "1100007",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/slots/ezugi-slots/777_Strike.png", alt: "" },
    },

    WillysChills: {
      href: "/casino/ezugi/WillysChills",
      code: "1100128",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: {
        src: "./images/slots/ezugi-slots/Willys_Hot_Chillies.png",
        alt: "",
      },
    },
  },
  roulettetab: {
    SpeedRoulette: {
      href: "/casino/aggapezugi-speed-roulette",
      code: "221000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/speed-roulette.png", alt: "" },
    },
    DiamondRoulette: {
      href: "/casino/aggapezugi-diamond-roulette",
      code: "221003",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/diamond-roulette.png", alt: "" },
    },
    NamasteRoulette: {
      href: "/casino/aggapezugi-namaste-roulette",
      code: "221005",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/mamaste-roulette.png", alt: "" },
    },
    
    AutoRoulette: {
      href: "/casino/aggapezugi-automatic-roulette",
      code: "5001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/auto-roulette.jpg", alt: "" },
    },
    SpeedAutoRoulette: {
      href: "/casino/aggapezugi-speed-auto-roulette",
      code: "221002",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/speed-auto-roulette.png", alt: "" },
    },
    OracleRoulette2: {
      href: "/casino/aggapezugi-oracle-casino-roulette-360",
      code: "611001",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/oracle-roulette-2.png", alt: "" },
    },
    PortomasoRoulette1: {
      href: "/casino/aggapezugi-portomaso-casino-roulette",
      code: "611004",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/portomaso-roulette-1.jpg", alt: "" },
    },
    ItalianRoulette: {
      href: "/casino/aggapezugi-italian-roulette",
      code: "1000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/italian-roulette.jpg", alt: "" },
    },
    SpanishRoulette: {
      href: "/casino/aggapezugi-cumbia-ruleta-1",
      code: "411000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/spanish-roulette.jpg", alt: "" },
    },
    PrestigeAutoRoulette: {
      href: "/casino/aggapezugi-prestige-auto-roulette",
      code: "221004",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/roulette/prestige-auto-oulette.jpg", alt: "" },
    },
    HandCasinoHoldem: {
      href: "/casino/evolution/HandCasinoHoldem",
      code: 507000,
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/11.png", alt: "" },
    },
  },
  baccarattab: {
   
    Knockoutbaccarat: {
      href: "/casino/aggapezugi-baccarat-knockout",
      code: "120",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/baccarat03.png", alt: "" },
    },
    Super6baccarat: {
      href: "/casino/aggapezugi-baccarat-super-six",
      code: "32100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/baccarat04.png", alt: "" },
    },
    Marinabaccarat: {
      href: "/casino/aggapezugi-marina-casino-baccarat-1",
      code: "130",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/baccarat05.png", alt: "" },
    },

    Marina02baccarat: {
      href: "/casino/aggapezugi-marina-casino-baccarat-2",
      code: "32101",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/baccarat06.png", alt: "" },
    },
   
    Baccarat: {
      href: "/casino/aggapezugi-baccarat",
      code: "106",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/baccarat08.png", alt: "" },
    },
    Baccaratpro02: {
      href: "/casino/aggapezugi-baccaratpro02",
      code: "101",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/baccarat/baccarat09.png", alt: "" },
    },
    
  },
  AndarBahartab: {
    AndarBaharLive: {
      href: "/casino/aggapezugi-andar-bahar",
      code: "228000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/andarbahar/AndarBahar01.png", alt: "" },
    },
    AndarBaharMarnia: {
      href: "/casino/aggapezugi-ott-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/andarbahar/AndarBahar02.png", alt: "" },
    },
  },
  TeenPattitab: {
    TeenPatti01: {
      href: "/casino/aggapezugi-teen-patti",
      code: "227100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/poker/Poker01.png", alt: "" },
    },
    
  },
  Blackjacktab: {
    Blackjack: {
      href: "/casino/aggapezugi-vip-blackjack",
      code: "201",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      cover: { src: "./images/blackjack/Blackjack01.png", alt: "" },
    },
   
   
  },
  thirtytwoCardtab: {
   
  },
  sevenLuckytab: {
    
  },
  sicbotab: {
    
  },
  ezugi: {
    
  },

  spribe: {
    href: "/casino/sprie",
    code: "",
    provider: "spribe",
    homeUrl: "",
    games: {
      mines: {
        href: "/casino/aggapspribe-mines",
        code: "mines",
        casino: "spribe",
        provider: "mines",
        homeUrl: "",
        cover: { src: "./images/spribe/02.jpg", alt: "" },
      },
      goal: {
        href: "/casino/aggapspribe-goal",
        code: "goal",
        casino: "spribe",
        provider: "goal",
        homeUrl: "",
        cover: { src: "./images/spribe/06.png", alt: "" },
      },
      dice: {
        href: "/casino/aggapspribe-dice",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: "",
        cover: { src: "./images/spribe/07.jpg", alt: "" },
      },
      aviator: {
        href: "/casino/aggapspribe-aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: "",
        cover: { src: "./images/spribe/03.png", alt: "" },
      },
      pilnko: {
        href: "/casino/aggapspribe-pilnko",
        code: "pilnko",
        casino: "spribe",
        provider: "pilnko",
        homeUrl: "",
        cover: { src: "./images/spribe/08.jpg", alt: "" },
      },
      miniroulette: {
        href: "/casino/aggapspribe-mini-roulette",
        code: "miniroulette",
        casino: "spribe",
        provider: "miniroulette",
        homeUrl: "",
        cover: { src: "./images/spribe/04.png", alt: "" },
      },
      hilo: {
        href: "/casino/aggapspribe-hilo",
        code: "hilo",
        casino: "miniroulette",
        provider: "hilo",
        homeUrl: "",
        cover: { src: "./images/spribe/05.png", alt: "" },
      },
    },
  },

  populartab: {
    slide1: {
      // AndarBaharVivo: {
      //   redirectUrl: "/casino/vivo-andar-bahar",
      //   code: "",
      //   casino: "vivo",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/popular/AndarBaharVivo.jpg",
      //   alt: "",
      //   name: "Andar Bahar Vivo",
      //   providerName: "Vivo",
      // },
      // TeenPattiVivo: {
      //   redirectUrl: "/casino/vivo-teen-patti",
      //   code: "",
      //   casino: "vivo",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/popular/TeenPattiVivo.jpg",
      //   alt: "",
      //   name: "Teen Patti Vivo",
      //   providerName: "Vivo",
      // },
    },
    name: "Popular",
  },
  roulettetab: {
    slide1: {
      SpeedRoulette: {
        redirectUrl: "/casino/aggapezugi-speed-roulette",
        code: "1000104",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/speed-roulette-evolution.jpg",
        alt: "",
        name: "Speed Roulette",
        providerName: "Evolution",
        category: CATEGORY_TYPE.MOST_POPULAR,
      },
      DiamondRoulette: {
        redirectUrl: "/casino/aggapezugi-diamond-roulette",
        code: "221003",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/DiamondRoulette.jpg",
        alt: "",
        name: "Diamond Roulette",
        providerName: "Ezugi",
      },
      NamasteRoulette: {
        redirectUrl: "/casino/aggapezugi-namaste-roulette",
        code: "221005",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Namasteroulette.jpg",
        alt: "",
        name: "Namaste Roulette",
        providerName: "Ezugi",
      },
      AutoRoulette: {
        redirectUrl: "/casino/aggapezugi-automatic-roulette",
        code: "5001",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/AutoRoulette.jpg",
        alt: "",
        name: "Auto Roulette",
        providerName: "Ezugi",
      },
      SpeedAutoRoulette: {
        redirectUrl: "/casino/aggapezugi-speed-auto-roulette",
        code: "1000103",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Speedautoroulleteevo.jpg",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Evolution",
      },
      
    },
    slide2: {
      SpanishRoulette: {
        redirectUrl: "/casino/aggapezugi-cumbia-ruleta-1",
        code: "421002",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/SpanishRoulette.jpg",
        alt: "",
        name: "Spanish Roulette",
        providerName: "Ezugi",
      },
      PrestigeAutoRoulette: {
        redirectUrl: "/casino/aggapezugi-prestige-auto-roulette",
        code: "221004",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Prestige-Auto-Roulette.jpg",
        alt: "",
        name: "Prestige Auto Roulette",
        providerName: "Ezugi",
      },
      PortomasoRoulette2: {
        redirectUrl: "/casino/aggapezugi-portomaso-casino-roulette",
        code: "611004",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/portomasoroulette2.jpg",
        alt: "",
        name: "Portomaso Roulette 2",
        providerName: "Ezugi",
      },
      
      RuletaRoulette: {
        redirectUrl: "/casino/aggapezugi-ruleta-del-sol",
        code: "611006",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/RuletadelSol.jpg",
        alt: "",
        name: "Ruleta del Sol",
        providerName: "Ezugi",
      },
      
      RNGRoulette: {
        redirectUrl: "/casino/aggapezugi-ez-roulette",
        code: "vs20stickysymbol",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/RNGRoulette.jpg",
        alt: "",
        name: "EZ RNG Roulette",
        providerName: "Ezugi",
      },
      instantRoulette: {
        redirectUrl: "/casino/ezgevo-instant-roulette",
        code: "227",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/InstantRoulette.jpg",
        alt: "",
        name: "Instant Roulette",
        providerName: "Evolution",
      },
      TurkishRoulette: {
        redirectUrl: "/casino/ezgevo-turkish-lightning-roulette",
        code: "102",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/TurkiceLightningRoulette.jpg",
        alt: "",
        name: "Turkish Lightning Roulette",
        providerName: "Evolution",
      },
    },
    
    name: "Roulette",
  },
  baccarattab: {
    slide1: {
      Baccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat",
        code: "100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat08.jpg",
        alt: "",
        name: "Baccarart",
        providerName: "Ezugi",
      },
    
      Knockoutbaccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat-knockout",
        code: "120",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat03.jpg",
        alt: "",
        name: "Knock Out Baccarart",
        providerName: "Ezugi",
      },
      Super6baccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat-super-six",
        code: "130",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat04.jpg",
        alt: "",
        name: "Super 6 Baccarart",
        providerName: "Ezugi",
      },
      Marinabaccarat: {
        redirectUrl: "/casino/aggapezugi-marina-casino-baccarat-1",
        code: "32100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat05.jpg",
        alt: "",
        name: "Casino Marina Baccarart 1",
        providerName: "Ezugi",
      },
      Marina02baccarat: {
        redirectUrl: "/casino/aggapezugi-marina-casino-baccarat-2",
        code: "32101",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat06.jpg",
        alt: "",
        name: "Casino Marina Baccarart 2",
        providerName: "Ezugi",
      },
     
    },
    slide2: {
      
      fortuneBaccarat: {
        redirectUrl: "/casino/aggapezugi-fortune-baccarat",
        code: "566",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/Fortunebaccarat.jpg",
        alt: "",
        name: "Fortune Baccarat",
        providerName: "Ezugi",
      },
      knockoutbaccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat-knockout",
        code: "570",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/KnockoutBaccarat.jpg",
        alt: "",
        name: "Knockout Baccarat",
        providerName: "Ezugi",
      },
    },
    name: "Baccarat",
  },
  Blackjacktab: {
    slide1: {
      Blackjack: {
        redirectUrl: "/casino/aggapezugi-vip-blackjack",
        code: "201",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack01.jpg",
        alt: "",
        name: "Blackjack",
        providerName: "Ezugi",
      },
      
      TurkceBlackjack2: {
        redirectUrl: "/casino/aggapezugi-turkce-rulet",
        code: "501",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/turkceblackjack2.jpg",
        alt: "",
        name: "Turkce Blackjack 2",
        providerName: "Ezugi",
      },
      
      FreebetBlackjack: {
        redirectUrl: "/casino/ezgevo-free-bet-blackjack-1",
        code: "1000066",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Free-Bet-Blackjack.jpg",
        alt: "",
        name: "Freebet Blackjack 1",
        providerName: "Evolution",
      },
      
    },
    slide2: {
      

      BlackjackParty: {
        redirectUrl: "/casino/ezgevo-blackjack-party",
        code: "502",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjackparty.jpg",
        alt: "",
        name: "Blackjack Party",
        providerName: "Evolution",
      },
      Rumbablackjack1: {
        redirectUrl: "/casino/aggapezugi-rumba-blackjack-1",
        code: "412",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/RumbaBlackjack.jpg",
        alt: "",
        name: "Rumba Blackjack 1",
        providerName: "Ezugi",
      },
      RumbaBlackjack4: {
        redirectUrl: "/casino/aggapezugi-rumba-blackjack-4",
        code: "414",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Rumba-Blackjack-4.jpg",
        alt: "",
        name: "Rumba Blackjack 4",
        providerName: "Ezugi",
      },
      
      speedvipBlackjackG: {
        redirectUrl: "/casino/ezgevo-speed-vip-blackjack-g",
        code: "504",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/SpeedVipBlackjackg.jpg",
        alt: "",
        name: "Speed VIP Blackjack G",
        providerName: "Ezugi",
      },
     
    
    },
    
    name: "Blackjack",
  },
  pokertab: {
    slide1: {
    
     
    },
    name: "Poker",
  },
  spribe: {
    slide1: {
      aviator: {
        redirectUrl: "/casino/aggapspribe-aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/aviator.gif",
        alt: "",
        name: "Aviator",
        providerName: "Spribe",
      },
      mines: {
        redirectUrl: "/casino/aggapspribe-mines",
        code: "mines",
        casino: "spribe",
        provider: "mines",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Mines.jpg",
        alt: "",
        name: "Mines",
        providerName: "Spribe",
      },
      goal: {
        redirectUrl: "/casino/aggapspribe-goal",
        code: "goal",
        casino: "spribe",
        provider: "goal",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Goal.jpg",
        alt: "",
        name: "Goal",
        providerName: "Spribe",
      },
      dice: {
        redirectUrl: "/casino/aggapspribe-dice",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Dice.jpg",
        alt: "",
        name: "Dice",
        providerName: "Spribe",
      },
      plinko: {
        redirectUrl: "/casino/aggapspribe-plinko",
        code: "plinko",
        casino: "spribe",
        provider: "plinko",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Plinko.jpg",
        alt: "",
        name: "Plinko",
        providerName: "Spribe",
      },
      miniroulette: {
        redirectUrl: "/casino/aggapspribe-mini-roulette",
        code: "mini-roulette",
        casino: "spribe",
        provider: "mini-roulette",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Mini-roulette.jpg",
        alt: "",
        name: "Mini Roulette",
        providerName: "Spribe",
      },
      hilo: {
        redirectUrl: "/casino/aggapspribe-hilo",
        code: "hi-lo",
        casino: "spribe",
        provider: "hi-lo",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/HIlo.jpg",
        alt: "",
        name: "Hilo",
        providerName: "Spribe",
      },
    },
    name: "Spribe",
  },
  Supernowa: {
    slide1: {
      // playerTP: {
      //   redirectUrl: "/casino/supernowa/playerTP",
      //   code: "D3TP",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/3PlayerTeenPatti.jpg",
      //   alt: "",
      //   name: "3 Player TeenPatti",
      //   providerName: "Supernowa",
      // },
      Cards32SN: {
        redirectUrl: "/casino/supernowa/Cards32SN",
        code: "C32",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/32Card.jpg",
        alt: "",
        name: "32 Cards",
        providerName: "Supernowa",
      },
      AkbarRomeoWalter: {
        redirectUrl: "/casino/supernowa/AkbarRomeoWalter",
        code: "ARW",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/AkbarRomeoWalter.jpg",
        alt: "",
        name: "Akbar Romeo Walter",
        providerName: "Supernowa",
      },
      AndarBaharSN: {
        redirectUrl: "/casino/supernowa/AndarBaharSN",
        code: "ABC",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/AndarBahar.jpg",
        alt: "",
        name: "Andar Bahar",
        providerName: "Supernowa",
      },
      BaccaratSN: {
        redirectUrl: "/casino/supernowa/BaccaratSN",
        code: "BAC",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/Baccarat.jpg",
        alt: "",
        name: "Baccarat",
        providerName: "Supernowa",
      },
      // CasinoQueen: {
      //   redirectUrl: "/casino/supernowa/CasinoQueen",
      //   code: "CQ",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/CasinoQueen.jpg",
      //   alt: "",
      //   name: "Casino Queen",
      //   providerName: "Supernowa",
      // },
      ClassicAndarBaharSN: {
        redirectUrl: "/casino/supernowa/ClassicAndarBaharSN",
        code: "AB",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/ClassicAndarBahar.jpg",
        alt: "",
        name: "Classic Andar Bahar",
        providerName: "Supernowa",
      },
      DragonTigerSN: {
        redirectUrl: "/casino/supernowa/DragonTigerSN",
        code: "DT7M",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/DragonTiger.jpg",
        alt: "",
        name: "Dragon Tiger",
        providerName: "Supernowa",
      },
      GoaAndarBaharSN: {
        redirectUrl: "/casino/supernowa/GoaAndarBaharSN",
        code: "AB2",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/GoasAndarBahar.jpg",
        alt: "",
        name: "Goa's Andar Bahar",
        providerName: "Supernowa",
      },
      RNGCricket2020: {
        redirectUrl: "/casino/supernowa/RNGCricket2020",
        code: "RCKT20",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGCricket2020.jpg",
        alt: "",
        name: "RNG Cricket 2020",
        providerName: "Supernowa",
      },
      RNGDragonTiger: {
        redirectUrl: "/casino/supernowa/RNGDragonTiger",
        code: "VDT",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNG-Dragon-Tiger.jpg",
        alt: "",
        name: "RNG Dragon Tiger",
        providerName: "Supernowa",
      },
      // KingRace: {
      //   redirectUrl: "/casino/supernowa/KingRace",
      //   code: "CR",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/KingRace.jpg",
      //   alt: "",
      //   name: "King Race",
      //   providerName: "Supernowa",
      // },
      Lucky7SN: {
        redirectUrl: "/casino/supernowa/Lucky7SN",
        code: "UD7",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/Lucky7.jpg",
        alt: "",
        name: "Lucky 7",
        providerName: "Supernowa",
      },
      RNGKingRace: {
        redirectUrl: "/casino/supernowa/RNGKingRace",
        code: "VCR",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGKingRace.jpg",
        alt: "",
        name: "RNG King Race",
        providerName: "Supernowa",
      },
      RNGLucky7: {
        redirectUrl: "/casino/supernowa/RNGLucky7",
        code: "VUD7",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGLucky7.jpg",
        alt: "",
        name: "RNG Lucky 7",
        providerName: "Supernowa",
      },
      // PokerSN: {
      //   redirectUrl: "/casino/supernowa/PokerSN",
      //   code: "PK",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/Poker.jpg",
      //   alt: "",
      //   name: "Poker",
      //   providerName: "Supernowa",
      // },
    },
    slide2: {
      RouletteSN: {
        redirectUrl: "/casino/supernowa/RouletteSN",
        code: "RT",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/Roulette.jpg",
        alt: "",
        name: "Roulette",
        providerName: "Supernowa",
      },
      TeenPattiSN: {
        redirectUrl: "/casino/supernowa/TeenPattiSN",
        code: "TP",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/Teen-Patti.jpg",
        alt: "",
        name: "Teen Patti",
        providerName: "Supernowa",
      },
      TeenPatti2020SN: {
        redirectUrl: "/casino/supernowa/TeenPatti2020SN",
        code: "TP20",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/TeenPatti2020.jpg",
        alt: "",
        name: "Teen Patti 2020",
        providerName: "Supernowa",
      },
      TeenPattiFaceOffSN: {
        redirectUrl: "/casino/supernowa/TeenPattiFaceOffSN",
        code: "TPFO",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/TeenPattiFaceOff.jpg",
        alt: "",
        name: "Teen Patti Face Off",
        providerName: "Supernowa",
      },
      // WorliMatka: {
      //   redirectUrl: "/casino/supernowa/WorliMatka",
      //   code: "WM",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/WorliMatka.jpg",
      //   alt: "",
      //   name: "Worli Matka",
      //   providerName: "Supernowa",
      // },
      // RNG3CardsJudgement: {
      //   redirectUrl: "/casino/supernowa/RNG3CardsJudgement",
      //   code: "V3CJ",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/RNG3CardsJudgement.jpg",
      //   alt: "",
      //   name: "RNG 3 Cards Judgement",
      //   providerName: "Supernowa",
      // },
      RNG3PlayerTeenPatti: {
        redirectUrl: "/casino/supernowa/RNG3PlayerTeenPatti",
        code: "V3TP",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNG3PlayerTeenPatti.jpg",
        alt: "",
        name: "RNG 3 Player Teen Patti",
        providerName: "Supernowa",
      },
      RNG32Cards: {
        redirectUrl: "/casino/supernowa/RNG32Cards",
        code: "VC32",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNG32Cards.jpg",
        alt: "",
        name: "RNG 32 Cards",
        providerName: "Supernowa",
      },
      RNGAkbarRomeoWalter: {
        redirectUrl: "/casino/supernowa/RNGAkbarRomeoWalter",
        code: "VARW",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGAkbarRomeoWalter.jpg",
        alt: "",
        name: "RNG Akbar Romeo Walter",
        providerName: "Supernowa",
      },
      // RNGAndarBahar2020: {
      //   redirectUrl: "/casino/supernowa/RNGAndarBahar2020",
      //   code: "VAB20",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/RNGAndarBahar2020.jpg",
      //   alt: "",
      //   name: "RNG Andar Bahar 2020",
      //   providerName: "Supernowa",
      // },
      RNGBaccarat: {
        redirectUrl: "/casino/supernowa/RNGBaccarat",
        code: "VBAC",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGBaccarat.jpg",
        alt: "",
        name: "RNG Baccarat",
        providerName: "Supernowa",
      },
      RNGCasinoQueen: {
        redirectUrl: "/casino/supernowa/RNGCasinoQueen",
        code: "RCQ",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGCasinoQueen.jpg",
        alt: "",
        name: "RNG Casino Queen",
        providerName: "Supernowa",
      },
      RNGCasinoQueen2020: {
        redirectUrl: "/casino/supernowa/RNGCasinoQueen2020",
        code: "RCQ20",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGCasinoQueen2020.jpg",
        alt: "",
        name: "RNG Casino Queen 2020",
        providerName: "Supernowa",
      },
      RNGDragonTiger2020: {
        redirectUrl: "/casino/supernowa/RNGDragonTiger2020",
        code: "VDT20",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGDragonTiger2020.jpg",
        alt: "",
        name: "RNG Dragon Tiger 2020",
        providerName: "Supernowa",
      },
      RNGJoker: {
        redirectUrl: "/casino/supernowa/RNGJoker",
        code: "VJKR",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGJoker.jpg",
        alt: "",
        name: "RNG Joker",
        providerName: "Supernowa",
      },
      // RNGBaccarat2020: {
      //   redirectUrl: "/casino/supernowa/RNGBaccarat2020",
      //   code: "VBAC20",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/RNGBaccarat2020.jpg",
      //   alt: "",
      //   name: "RNG Baccarat 2020",
      //   providerName: "Supernowa",
      // },
    },
    // slide3: {
    // RNGKabutarFuddi: {
    //   redirectUrl: "/casino/supernowa/RNGKabutarFuddi",
    //   code: "VKF",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   imgUrl: "./images/supernowa/RNGKabutarFuddi.jpg",
    //   alt: "",
    //   name: "RNG Kabutar Fuddi",
    //   providerName: "Supernowa",
    // },

    // RNGPoker: {
    //   redirectUrl: "/casino/supernowa/RNGPoker",
    //   code: "VPK",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   imgUrl: "./images/supernowa/RNGPoker.jpg",
    //   alt: "",
    //   name: "RNG Poker",
    //   providerName: "Supernowa",
    // },
    // RNGPoker2020: {
    //   redirectUrl: "/casino/supernowa/RNGPoker2020",
    //   code: "VPK20",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   imgUrl: "./images/supernowa/RNGPoker2020.jpg",
    //   alt: "",
    //   name: "RNG Poker 2020",
    //   providerName: "Supernowa",
    // },
    // RNGTeenPatti: {
    //   redirectUrl: "/casino/supernowa/RNGTeenPatti",
    //   code: "VTP",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   imgUrl: "./images/supernowa/RNGTeenPatti.jpg",
    //   alt: "",
    //   name: "RNG Teen Patti",
    //   providerName: "Supernowa",
    // },
    // RNGTeenPatti2020: {
    //   redirectUrl: "/casino/supernowa/RNGTeenPatti2020",
    //   code: "VTP20",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   imgUrl: "./images/supernowa/RNGTeenPatti2020.jpg",
    //   alt: "",
    //   name: "RNG Teen Patti 2020",
    //   providerName: "Supernowa",
    // },
    // RNGWorliMatka: {
    //   redirectUrl: "/casino/supernowa/RNGWorliMatka",
    //   code: "VWM",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   imgUrl: "./images/supernowa/RNGWorliMatka.jpg",
    //   alt: "",
    //   name: "RNG Worli Matka",
    //   providerName: "Supernowa",
    // },
    // },
    name: "Supernowa",
  },
  // Vivo: {
  //   slide1: {
  //     CoffeeWild: {
  //       redirectUrl: "/casino/vivo-dragon-tiger",
  //       imgUrl: "./images/Vivo/DragonTiger.jpg",
  //       name: "Dragon Tiger",
  //       providerName: "Vivo",
  //     },
  //     EuropeanAutoRoulette: {
  //       redirectUrl: "/casino/vivo-european-auto-roulette",
  //       imgUrl: "./images/Vivo/EuropeanAutoRoulette.jpg",
  //       name: "European Auto Roulette",
  //       providerName: "Vivo",
  //     },
  //     FrenchRoulette: {
  //       redirectUrl: "/casino/vivo-french-roulette",
  //       imgUrl: "./images/Vivo/FrenchRoulette.jpg",
  //       name: "French Roulette",
  //       providerName: "Vivo",
  //     },
  //     GalaxyBaccarat1: {
  //       redirectUrl: "/casino/vivo-galaxy-baccarat-1",
  //       imgUrl: "./images/Vivo/GalaxyBaccarat1.jpg",
  //       name: "Galaxy Baccarat1",
  //       providerName: "Vivo",
  //     },
  //     GalaxyBaccarat2: {
  //       redirectUrl: "/casino/vivo-galaxy-baccarat-2",
  //       imgUrl: "./images/Vivo/GalaxyBaccarat2.jpg",
  //       name: "Galaxy Baccarat 2",
  //       providerName: "Vivo",
  //     },
  //     GalaxyBaccarat3: {
  //       redirectUrl: "/casino/vivo-galaxy-baccarat-3",
  //       imgUrl: "./images/Vivo/GalaxyBaccarat3.jpg",
  //       name: "Galaxy Baccarat 3",
  //       providerName: "Vivo",
  //     },
  //     GalaxyRoulette: {
  //       redirectUrl: "/casino/vivo-galaxy-roulette",
  //       imgUrl: "./images/Vivo/GalaxyRoulette.jpg",
  //       name: "Galaxy Roulette",
  //       providerName: "Vivo",
  //     },
  //     MacauBaccarat: {
  //       redirectUrl: "/casino/vivo-macau-baccarat",
  //       imgUrl: "./images/Vivo/MacauBaccarat.jpg",
  //       name: "Macau Baccarat",
  //       providerName: "Vivo",
  //     },
  //     Oracle360Roulette: {
  //       redirectUrl: "/casino/vivo-oracle-360-roulette",
  //       imgUrl: "./images/Vivo/Oracle360Roulette.jpg",
  //       name: "Oracle 360 Roulette",
  //       providerName: "Vivo",
  //     },
  //     OracleBlazeRoulette: {
  //       redirectUrl: "/casino/vivo-oracle-blaze-roulette",
  //       imgUrl: "./images/Vivo/OracleBlazeRoulette.jpg",
  //       name: "Oracle Blaze Roulette",
  //       providerName: "Vivo",
  //     },
  //     PortomasoRoulette: {
  //       redirectUrl: "/casino/vivo-portomaso-roulette",
  //       imgUrl: "./images/Vivo/PortomasoRoulette.jpg",
  //       name: "Portomaso Roulette",
  //       providerName: "Vivo",
  //     },
  //     TeenPatti: {
  //       redirectUrl: "/casino/vivo-teen-patti",
  //       imgUrl: "./images/Vivo/TeenPatti.jpg",
  //       name: "Teen Patti",
  //       providerName: "Vivo",
  //     },
  //   },
  //   // slide2: {
  //   //   VABacarat1: {
  //   //     redirectUrl: "/casino/vivo-va-bacarat-1",
  //   //     imgUrl: "./images/Vivo/VABacarat1.jpg",
  //   //     name: "VA Bacarat 1",
  //   //     providerName: "Vivo",
  //   //   },
  //   //   VABacarat2: {
  //   //     redirectUrl: "/casino/vivo-va-bacarat-2",
  //   //     imgUrl: "./images/Vivo/VABacarat2.jpg",
  //   //     name: "VA Bacarat 2",
  //   //     providerName: "Vivo",
  //   //   },
  //   //   VABacarat3: {
  //   //     redirectUrl: "/casino/vivo-va-bacarat-3",
  //   //     imgUrl: "./images/Vivo/VABacarat3.jpg",
  //   //     name: "VA Bacarat 3",
  //   //     providerName: "Vivo",
  //   //   },
  //   //   VABacarat4: {
  //   //     redirectUrl: "/casino/vivo-va-bacarat-4",
  //   //     imgUrl: "./images/Vivo/VABacarat4.jpg",
  //   //     name: "VA Bacarat 4",
  //   //     providerName: "Vivo",
  //   //   },
  //   //   VABacarat5: {
  //   //     redirectUrl: "/casino/vivo-va-bacarat-5",
  //   //     imgUrl: "./images/Vivo/VABacarat5.jpg",
  //   //     name: "VA Bacarat 5",
  //   //     providerName: "Vivo",
  //   //   },
  //   // },
  //   name: "Vivo",
  // },
  
  TvShows: {
    slide1: {
      
      
    },
    name: "TV Games",
  },
  AllGames: {
    slide1: {
      SpeedRoulette: {
        redirectUrl: "/casino/aggapezugi-speed-roulette",
        code: "1000104",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/speed-roulette-evolution.jpg",
        alt: "",
        name: "Speed Roulette",
        providerName: "Evolution",
      },
      DiamondRoulette: {
        redirectUrl: "/casino/aggapezugi-diamond-roulette",
        code: "221003",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/DiamondRoulette.jpg",
        alt: "",
        name: "Diamond Roulette",
        providerName: "Ezugi",
      },
      NamasteRoulette: {
        redirectUrl: "/casino/aggapezugi-namaste-roulette",
        code: "221005",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Namasteroulette.jpg",
        alt: "",
        name: "Namaste Roulette",
        providerName: "Ezugi",
      },
      AutoRoulette: {
        redirectUrl: "/casino/aggapezugi-automatic-roulette",
        code: "5001",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/AutoRoulette.jpg",
        alt: "",
        name: "Auto Roulette",
        providerName: "Ezugi",
      },
      SpeedAutoRoulette: {
        redirectUrl: "/casino/aggapezugi-speed-auto-roulette",
        code: "1000103",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Speedautoroulleteevo.jpg",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Evolution",
      },
      
    },
    slide2: {
     
      PrestigeAutoRoulette: {
        redirectUrl: "/casino/aggapezugi-prestige-auto-roulette",
        code: "221004",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Prestige-Auto-Roulette.jpg",
        alt: "",
        name: "Prestige Auto Roulette",
        providerName: "Ezugi",
      },
  

    },
    slide3: {
      Baccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat",
        code: "100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat08.jpg",
        alt: "",
        name: "Baccarart",
        providerName: "Ezugi",
      },
     
      Knockoutbaccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat-knockout",
        code: "120",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat03.jpg",
        alt: "",
        name: "Knock Out Baccarart",
        providerName: "Ezugi",
      },
      Super6baccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat-super-six",
        code: "130",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat04.jpg",
        alt: "",
        name: "Super 6 Baccarart",
        providerName: "Ezugi",
      },
      Marinabaccarat: {
        redirectUrl: "/casino/aggapezugi-marina-casino-baccarat-1",
        code: "32100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat05.jpg",
        alt: "",
        name: "Casino Marina Baccarart 1",
        providerName: "Ezugi",
      },

      Marina02baccarat: {
        redirectUrl: "/casino/aggapezugi-marina-casino-baccarat-2",
        code: "32101",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat06.jpg",
        alt: "",
        name: "Casino Marina Baccarart 2",
        providerName: "Ezugi",
      },
    
    },
    slide4: {
      
    },
    slide5: {
      Blackjack: {
        redirectUrl: "/casino/aggapezugi-vip-blackjack",
        code: "201",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack01.jpg",
        alt: "",
        name: "Blackjack",
        providerName: "Ezugi",
      },

     
    },
    slide6: {
     

    },
    slide7: {
      
    
    },
    slide8: {
      aviator: {
        redirectUrl: "/casino/aggapspribe-aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/aviator.gif",
        alt: "",
        name: "Aviator",
        providerName: "Spribe", 
      },
      mines: {
        redirectUrl: "/casino/aggapspribe-mines",
        code: "mines",
        casino: "spribe",
        provider: "mines",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Mines.jpg",
        alt: "",
        name: "Mines",
        providerName: "Spribe",
      },
      goal: {
        redirectUrl: "/casino/aggapspribe-goal",
        code: "goal",
        casino: "spribe",
        provider: "goal",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Goal.jpg",
        alt: "",
        name: "Goal",
        providerName: "Spribe",
      },
      dice: {
        redirectUrl: "/casino/aggapspribe-dice",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Dice.jpg",
        alt: "",
        name: "Dice",
        providerName: "Spribe",
      },
      plinko: {
        redirectUrl: "/casino/aggapspribe-plinko",
        code: "plinko",
        casino: "spribe",
        provider: "plinko",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Plinko.jpg",
        alt: "",
        name: "Plinko",
        providerName: "Spribe",
      },
      miniroulette: {
        redirectUrl: "/casino/aggapspribe-mini-roulette",
        code: "mini-roulette",
        casino: "spribe",
        provider: "mini-roulette",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Mini-roulette.jpg",
        alt: "",
        name: "Mini Roulette",
        providerName: "Spribe",
      },
      hilo: {
        redirectUrl: "/casino/aggapspribe-hilo",
        code: "hi-lo",
        casino: "spribe",
        provider: "hi-lo",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/HIlo.jpg",
        alt: "",
        name: "Hilo",
        providerName: "Spribe",
      },
    },
    slide9: {
     
    },
    name: "All Games",
  },
 

  Gamelobby: {
    slide1: {
      ezugi: {
        redirectUrl: "/casino/aggapezugi-ezugi-lobby",
        code: "",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/providers/slotspage/ezugi.gif",
        alt: "",
        name: "Ezugi",
        providerName: "Ezugi",
      },
      evolution: {
        redirectUrl: "/casino/evolution",
        code: "",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/providers/slotspage/Evolution.png",
        alt: "",
        name: "Evolution",
        providerName: "Evolution",
      },
      supernowa: {
        redirectUrl: "/casino/supernowa",
        code: "",
        casino: "wco",
        provider: "SN",
        homeUrl: "",
        imgUrl: "./images/providers/slotspage/Supernowa.png",
        alt: "",
        games: {},
        name: "Supernowa",
        providerName: "Supernowa",
      },
      worldcasino: {
        redirectUrl: "/casino/worldcasino",
        code: "",
        casino: "wco",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/providers/slotspage/WorldCasino.png",
        alt: "",
        games: {},
        name: "World Casino",
        providerName: "World Casino",
      },
      // xpg: {
      //   redirectUrl: "/casino/xpg",
      //   code: "",
      //   casino: "wco",
      //   provider: "XPG",
      //   homeUrl: "",
      //   imgUrl: "./images/providers/slotspage/XPG.jpg",
      //   alt: "",
      //   games: {},
      //   name: "XPG",
      //   providerName: "XPG",
      // },
      // onetouch: {
      //   redirectUrl: "/casino/onetouch",
      //   code: "",
      //   casino: "wco",
      //   provider: "OT",
      //   homeUrl: "",
      //   cover: { src: "./images/providers/new/OneTouch.png", alt: "" },
      //   imgUrl: "./images/providers/slotspage/OneTouch.jpg",
      //   alt: "",
      //   games: {},
      //   name: "One Touch",
      //   providerName: "One Touch",
      // },
      // onlyplay: {
      //   redirectUrl: "/casino/onlyplay",
      //   code: "",
      //   casino: "wco",
      //   provider: "GT",
      //   homeUrl: "",
      //   imgUrl: "./images/providers/slotspage/OnlyPlay.png",
      //   alt: "",
      //   games: {},
      //   name: "Only Play",
      //   providerName: "Only Play",
      // },
      // pragmaticplay: {
      //   redirectUrl: "/casino/pragmaticplay",
      //   code: "",
      //   casino: "wco",
      //   provider: "PP",
      //   homeUrl: "",
      //   imgUrl: "./images/providers/slotspage/Pragamatic.png",
      //   alt: "",
      //   games: {},
      //   name: "Pragmatic Play",
      //   providerName: "Pragmatic Play",
      // },

      // vivo: {
      //   redirectUrl: "/casino/vivo",
      //   code: "vivo",
      //   casino: "vivo",
      //   provider: "",
      //   homeUrl: "",
      //   imgUrl: "./images/providers/slotspage/Vivo.jpg",
      //   name: "Vivo Gaming",
      //   providerName: "Vivo",
      // },
    },
    name: "Game Lobby",
  },
};

export const casinoSliderData = {
  populartab: {
    slide1: {
      // AndarBaharVivo: {
      //   redirectUrl: "/casino/vivo-andar-bahar",
      //   code: "",
      //   casino: "vivo",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/popular/AndarBaharVivo.jpg",
      //   alt: "",
      //   name: "Andar Bahar Vivo",
      //   providerName: "Vivo",
      //   category: CATEGORY_TYPE.MOST_POPULAR,
      // },
      // TeenPattiVivo: {
      //   redirectUrl: "/casino/vivo-teen-patti",
      //   code: "",
      //   casino: "vivo",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/popular/TeenPattiVivo.jpg",
      //   alt: "",
      //   name: "Teen Patti Vivo",
      //   providerName: "Vivo",
      //   category: CATEGORY_TYPE.MOST_POPULAR,
      // },
    },
    name: "Popular",
  },
  roulettetab: {
    slide1: {
      SpeedRoulette: {
        redirectUrl: "/casino/aggapezugi-speed-roulette",
        code: "1000104",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/speed-roulette-evolution.jpg",
        alt: "",
        name: "Speed Roulette",
        providerName: "Evolution",
        category: CATEGORY_TYPE.MOST_POPULAR,
      },
      DiamondRoulette: {
        redirectUrl: "/casino/aggapezugi-diamond-roulette",
        code: "221003",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/DiamondRoulette.jpg",
        alt: "",
        name: "Diamond Roulette",
        providerName: "Ezugi",
        category: CATEGORY_TYPE.MOST_POPULAR,
      },
      NamasteRoulette: {
        redirectUrl: "/casino/aggapezugi-namaste-roulette",
        code: "221005",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Namasteroulette.jpg",
        alt: "",
        name: "Namaste Roulette",
        providerName: "Ezugi",
        category: CATEGORY_TYPE.MOST_POPULAR,
      },
      AutoRoulette: {
        redirectUrl: "/casino/aggapezugi-automatic-roulette",
        code: "5001",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/AutoRoulette.jpg",
        alt: "",
        name: "Auto Roulette",
        providerName: "Ezugi",
        category: CATEGORY_TYPE.NEWEST,
      },
      SpeedAutoRoulette: {
        redirectUrl: "/casino/aggapezugi-speed-auto-roulette",
        code: "1000103",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Speedautoroulleteevo.jpg",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Evolution",
        category: CATEGORY_TYPE.NEWEST,
      },
      
    },
    slide2: {
      SpanishRoulette: {
        redirectUrl: "/casino/aggapezugi-cumbia-ruleta-1",
        code: "421002",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/SpanishRoulette.jpg",
        alt: "",
        name: "Spanish Roulette",
        providerName: "Ezugi",
      },
      PrestigeAutoRoulette: {
        redirectUrl: "/casino/aggapezugi-prestige-auto-roulette",
        code: "221004",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Prestige-Auto-Roulette.jpg",
        alt: "",
        name: "Prestige Auto Roulette",
        providerName: "Ezugi",
      },
      PortomasoRoulette2: {
        redirectUrl: "/casino/aggapezugi-portomaso-casino-roulette",
        code: "611004",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/portomasoroulette2.jpg",
        alt: "",
        name: "Portomaso Roulette 2",
        providerName: "Ezugi",
      },
      
      RNGRoulette: {
        redirectUrl: "/casino/aggapezugi-ez-roulette",
        code: "vs20stickysymbol",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/RNGRoulette.jpg",
        alt: "",
        name: "EZ RNG Roulette",
        providerName: "Ezugi",
      },
      instantRoulette: {
        redirectUrl: "/casino/ezgevo-instant-roulette",
        code: "227",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/InstantRoulette.jpg",
        alt: "",
        name: "Instant Roulette",
        providerName: "Evolution",
      },
      TurkishRoulette: {
        redirectUrl: "/casino/ezgevo-turkish-lightning-roulette",
        code: "102",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/TurkiceLightningRoulette.jpg",
        alt: "",
        name: "Turkish Lightning Roulette",
        providerName: "Evolution",
      },
    },
   
    name: "Roulette",
  },
  baccarattab: {
    slide1: {
      Baccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat",
        code: "100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat08.jpg",
        alt: "",
        name: "Baccarart",
        providerName: "Ezugi",
        category: CATEGORY_TYPE.MOST_POPULAR,
      },
     
      Knockoutbaccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat-knockout",
        code: "120",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat03.jpg",
        alt: "",
        name: "Knock Out Baccarart",
        providerName: "Ezugi",
      },
      Super6baccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat-super-six",
        code: "130",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat04.jpg",
        alt: "",
        name: "Super 6 Baccarart",
        providerName: "Ezugi",
      },
      Marinabaccarat: {
        redirectUrl: "/casino/aggapezugi-marina-casino-baccarat-1",
        code: "32100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat05.jpg",
        alt: "",
        name: "Casino Marina Baccarart 1",
        providerName: "Ezugi",
        category: CATEGORY_TYPE.MOST_POPULAR,
      },
      Marina02baccarat: {
        redirectUrl: "/casino/aggapezugi-marina-casino-baccarat-2",
        code: "32101",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat06.jpg",
        alt: "",
        name: "Casino Marina Baccarart 2",
        providerName: "Ezugi",
      },
      
      fortuneBaccarat: {
        redirectUrl: "/casino/aggapezugi-fortune-baccarat",
        code: "566",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/Fortunebaccarat.jpg",
        alt: "",
        name: "Fortune Baccarat",
        providerName: "Ezugi",
      },
      knockoutbaccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat-knockout",
        code: "570",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/KnockoutBaccarat.jpg",
        alt: "",
        name: "Knockout Baccarat",
        providerName: "Ezugi",
        category: CATEGORY_TYPE.NEWEST,
      },
    },
    name: "Baccarat",
  },
  Blackjacktab: {
    slide1: {
      Blackjack: {
        redirectUrl: "/casino/aggapezugi-vip-blackjack",
        code: "201",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack01.jpg",
        alt: "",
        name: "Blackjack",
        providerName: "Ezugi",
        category: CATEGORY_TYPE.MOST_POPULAR,
      },
      
      FreebetBlackjack: {
        redirectUrl: "/casino/ezgevo-free-bet-blackjack-1",
        code: "1000066",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Free-Bet-Blackjack.jpg",
        alt: "",
        name: "Freebet Blackjack 1",
        category: CATEGORY_TYPE.NEWEST,
        providerName: "Evolution",
      },
      
    },
    slide2: {
    

      BlackjackParty: {
        redirectUrl: "/casino/ezgevo-blackjack-party",
        code: "502",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjackparty.jpg",
        alt: "",
        name: "Blackjack Party",
        category: CATEGORY_TYPE.NEWEST,
        providerName: "Evolution",
      },
      Rumbablackjack1: {
        redirectUrl: "/casino/aggapezugi-rumba-blackjack-1",
        code: "412",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/RumbaBlackjack.jpg",
        alt: "",
        name: "Rumba Blackjack 1",
        providerName: "Ezugi",
      },
      RumbaBlackjack4: {
        redirectUrl: "/casino/aggapezugi-rumba-blackjack-4",
        code: "414",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Rumba-Blackjack-4.jpg",
        alt: "",
        name: "Rumba Blackjack 4",
        providerName: "Ezugi",
      },
     
      speedvipBlackjackG: {
        redirectUrl: "/casino/ezgevo-speed-vip-blackjack-g",
        code: "504",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/SpeedVipBlackjackg.jpg",
        alt: "",
        name: "Speed VIP Blackjack G",
        category: CATEGORY_TYPE.NEWEST,
        providerName: "Ezugi",
      },
    
     
    },
  
    name: "Blackjack",
  },
  pokertab: {
    slide1: {
      
    
    },
    name: "Poker",
  },
  spribe: {
    slide1: {
      aviator: {
        redirectUrl: "/casino/aggapspribe-aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/aviator.gif",
        alt: "",
        name: "Aviator",
        providerName: "Spribe",
      },
      mines: {
        redirectUrl: "/casino/aggapspribe-mines",
        code: "mines",
        casino: "spribe",
        provider: "mines",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Mines.jpg",
        alt: "",
        name: "Mines",
        providerName: "Spribe",
      },
      goal: {
        redirectUrl: "/casino/aggapspribe-goal",
        code: "goal",
        casino: "spribe",
        provider: "goal",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Goal.jpg",
        alt: "",
        name: "Goal",
        providerName: "Spribe",
      },
      dice: {
        redirectUrl: "/casino/aggapspribe-dice",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Dice.jpg",
        alt: "",
        name: "Dice",
        providerName: "Spribe",
      },
      plinko: {
        redirectUrl: "/casino/aggapspribe-plinko",
        code: "plinko",
        casino: "spribe",
        provider: "plinko",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Plinko.jpg",
        alt: "",
        name: "Plinko",
        providerName: "Spribe",
      },
      miniroulette: {
        redirectUrl: "/casino/aggapspribe-mini-roulette",
        code: "mini-roulette",
        casino: "spribe",
        provider: "mini-roulette",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Mini-roulette.jpg",
        alt: "",
        name: "Mini Roulette",
        providerName: "Spribe",
      },
      hilo: {
        redirectUrl: "/casino/aggapspribe-hilo",
        code: "hi-lo",
        casino: "spribe",
        provider: "hi-lo",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/HIlo.jpg",
        alt: "",
        name: "Hilo",
        providerName: "Spribe",
      },
    },
    name: "Spribe",
  },
  Supernowa: {
    slide1: {
      // playerTP: {
      //   redirectUrl: "/casino/supernowa/playerTP",
      //   code: "D3TP",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/3PlayerTeenPatti.jpg",
      //   alt: "",
      //   name: "3 Player TeenPatti",
      //   providerName: "Supernowa",
      // },
      Cards32SN: {
        redirectUrl: "/casino/supernowa/Cards32SN",
        code: "C32",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/32Card.jpg",
        alt: "",
        name: "32 Cards",
        providerName: "Supernowa",
      },
      AkbarRomeoWalter: {
        redirectUrl: "/casino/supernowa/AkbarRomeoWalter",
        code: "ARW",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/AkbarRomeoWalter.jpg",
        alt: "",
        name: "Akbar Romeo Walter",
        providerName: "Supernowa",
      },
      AndarBaharSN: {
        redirectUrl: "/casino/supernowa/AndarBaharSN",
        code: "ABC",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/AndarBahar.jpg",
        alt: "",
        name: "Andar Bahar",
        providerName: "Supernowa",
      },
      BaccaratSN: {
        redirectUrl: "/casino/supernowa/BaccaratSN",
        code: "BAC",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/Baccarat.jpg",
        alt: "",
        name: "Baccarat",
        providerName: "Supernowa",
      },
      // CasinoQueen: {
      //   redirectUrl: "/casino/supernowa/CasinoQueen",
      //   code: "CQ",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/CasinoQueen.jpg",
      //   alt: "",
      //   name: "Casino Queen",
      //   providerName: "Supernowa",
      // },
      ClassicAndarBaharSN: {
        redirectUrl: "/casino/supernowa/ClassicAndarBaharSN",
        code: "AB",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/ClassicAndarBahar.jpg",
        alt: "",
        name: "Classic Andar Bahar",
        providerName: "Supernowa",
      },
      DragonTigerSN: {
        redirectUrl: "/casino/supernowa/DragonTigerSN",
        code: "DT7M",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/DragonTiger.jpg",
        alt: "",
        name: "Dragon Tiger",
        providerName: "Supernowa",
      },
      GoaAndarBaharSN: {
        redirectUrl: "/casino/supernowa/GoaAndarBaharSN",
        code: "AB2",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/GoasAndarBahar.jpg",
        alt: "",
        name: "Goa's Andar Bahar",
        providerName: "Supernowa",
      },
      RNGCricket2020: {
        redirectUrl: "/casino/supernowa/RNGCricket2020",
        code: "RCKT20",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGCricket2020.jpg",
        alt: "",
        name: "RNG Cricket 2020",
        providerName: "Supernowa",
      },
      RNGDragonTiger: {
        redirectUrl: "/casino/supernowa/RNGDragonTiger",
        code: "VDT",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNG-Dragon-Tiger.jpg",
        alt: "",
        name: "RNG Dragon Tiger",
        providerName: "Supernowa",
      },
      // KingRace: {
      //   redirectUrl: "/casino/supernowa/KingRace",
      //   code: "CR",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/KingRace.jpg",
      //   alt: "",
      //   name: "King Race",
      //   providerName: "Supernowa",
      // },
      Lucky7SN: {
        redirectUrl: "/casino/supernowa/Lucky7SN",
        code: "UD7",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/Lucky7.jpg",
        alt: "",
        name: "Lucky 7",
        providerName: "Supernowa",
      },
      RNGKingRace: {
        redirectUrl: "/casino/supernowa/RNGKingRace",
        code: "VCR",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGKingRace.jpg",
        alt: "",
        name: "RNG King Race",
        providerName: "Supernowa",
      },
      RNGLucky7: {
        redirectUrl: "/casino/supernowa/RNGLucky7",
        code: "VUD7",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGLucky7.jpg",
        alt: "",
        name: "RNG Lucky 7",
        providerName: "Supernowa",
      },
      // PokerSN: {
      //   redirectUrl: "/casino/supernowa/PokerSN",
      //   code: "PK",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/Poker.jpg",
      //   alt: "",
      //   name: "Poker",
      //   providerName: "Supernowa",
      // },
    },
    slide2: {
      RouletteSN: {
        redirectUrl: "/casino/supernowa/RouletteSN",
        code: "RT",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/Roulette.jpg",
        alt: "",
        name: "Roulette",
        providerName: "Supernowa",
      },
      TeenPattiSN: {
        redirectUrl: "/casino/supernowa/TeenPattiSN",
        code: "TP",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/Teen-Patti.jpg",
        alt: "",
        name: "Teen Patti",
        providerName: "Supernowa",
      },
      TeenPatti2020SN: {
        redirectUrl: "/casino/supernowa/TeenPatti2020SN",
        code: "TP20",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/TeenPatti2020.jpg",
        alt: "",
        name: "Teen Patti 2020",
        providerName: "Supernowa",
      },
      TeenPattiFaceOffSN: {
        redirectUrl: "/casino/supernowa/TeenPattiFaceOffSN",
        code: "TPFO",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/TeenPattiFaceOff.jpg",
        alt: "",
        name: "Teen Patti Face Off",
        providerName: "Supernowa",
      },
      // WorliMatka: {
      //   redirectUrl: "/casino/supernowa/WorliMatka",
      //   code: "WM",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/WorliMatka.jpg",
      //   alt: "",
      //   name: "Worli Matka",
      //   providerName: "Supernowa",
      // },
      // RNG3CardsJudgement: {
      //   redirectUrl: "/casino/supernowa/RNG3CardsJudgement",
      //   code: "V3CJ",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/RNG3CardsJudgement.jpg",
      //   alt: "",
      //   name: "RNG 3 Cards Judgement",
      //   providerName: "Supernowa",
      // },
      RNG3PlayerTeenPatti: {
        redirectUrl: "/casino/supernowa/RNG3PlayerTeenPatti",
        code: "V3TP",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNG3PlayerTeenPatti.jpg",
        alt: "",
        name: "RNG 3 Player Teen Patti",
        providerName: "Supernowa",
      },
      RNG32Cards: {
        redirectUrl: "/casino/supernowa/RNG32Cards",
        code: "VC32",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNG32Cards.jpg",
        alt: "",
        name: "RNG 32 Cards",
        providerName: "Supernowa",
      },
      RNGAkbarRomeoWalter: {
        redirectUrl: "/casino/supernowa/RNGAkbarRomeoWalter",
        code: "VARW",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGAkbarRomeoWalter.jpg",
        alt: "",
        name: "RNG Akbar Romeo Walter",
        providerName: "Supernowa",
      },
      // RNGAndarBahar2020: {
      //   redirectUrl: "/casino/supernowa/RNGAndarBahar2020",
      //   code: "VAB20",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/RNGAndarBahar2020.jpg",
      //   alt: "",
      //   name: "RNG Andar Bahar 2020",
      //   providerName: "Supernowa",
      // },
      RNGBaccarat: {
        redirectUrl: "/casino/supernowa/RNGBaccarat",
        code: "VBAC",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGBaccarat.jpg",
        alt: "",
        name: "RNG Baccarat",
        providerName: "Supernowa",
      },
      RNGCasinoQueen: {
        redirectUrl: "/casino/supernowa/RNGCasinoQueen",
        code: "RCQ",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGCasinoQueen.jpg",
        alt: "",
        name: "RNG Casino Queen",
        providerName: "Supernowa",
      },
      RNGCasinoQueen2020: {
        redirectUrl: "/casino/supernowa/RNGCasinoQueen2020",
        code: "RCQ20",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGCasinoQueen2020.jpg",
        alt: "",
        name: "RNG Casino Queen 2020",
        providerName: "Supernowa",
      },
      RNGDragonTiger2020: {
        redirectUrl: "/casino/supernowa/RNGDragonTiger2020",
        code: "VDT20",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGDragonTiger2020.jpg",
        alt: "",
        name: "RNG Dragon Tiger 2020",
        providerName: "Supernowa",
      },
      RNGJoker: {
        redirectUrl: "/casino/supernowa/RNGJoker",
        code: "VJKR",
        casino: "wco",
        provider: "SN",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/supernowa/RNGJoker.jpg",
        alt: "",
        name: "RNG Joker",
        providerName: "Supernowa",
      },
      // RNGBaccarat2020: {
      //   redirectUrl: "/casino/supernowa/RNGBaccarat2020",
      //   code: "VBAC20",
      //   casino: "wco",
      //   provider: "SN",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/supernowa/RNGBaccarat2020.jpg",
      //   alt: "",
      //   name: "RNG Baccarat 2020",
      //   providerName: "Supernowa",
      // },
    },
    // slide3: {
    // RNGKabutarFuddi: {
    //   redirectUrl: "/casino/supernowa/RNGKabutarFuddi",
    //   code: "VKF",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   imgUrl: "./images/supernowa/RNGKabutarFuddi.jpg",
    //   alt: "",
    //   name: "RNG Kabutar Fuddi",
    //   providerName: "Supernowa",
    // },

    // RNGPoker: {
    //   redirectUrl: "/casino/supernowa/RNGPoker",
    //   code: "VPK",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   imgUrl: "./images/supernowa/RNGPoker.jpg",
    //   alt: "",
    //   name: "RNG Poker",
    //   providerName: "Supernowa",
    // },
    // RNGPoker2020: {
    //   redirectUrl: "/casino/supernowa/RNGPoker2020",
    //   code: "VPK20",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   imgUrl: "./images/supernowa/RNGPoker2020.jpg",
    //   alt: "",
    //   name: "RNG Poker 2020",
    //   providerName: "Supernowa",
    // },
    // RNGTeenPatti: {
    //   redirectUrl: "/casino/supernowa/RNGTeenPatti",
    //   code: "VTP",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   imgUrl: "./images/supernowa/RNGTeenPatti.jpg",
    //   alt: "",
    //   name: "RNG Teen Patti",
    //   providerName: "Supernowa",
    // },
    // RNGTeenPatti2020: {
    //   redirectUrl: "/casino/supernowa/RNGTeenPatti2020",
    //   code: "VTP20",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   imgUrl: "./images/supernowa/RNGTeenPatti2020.jpg",
    //   alt: "",
    //   name: "RNG Teen Patti 2020",
    //   providerName: "Supernowa",
    // },
    // RNGWorliMatka: {
    //   redirectUrl: "/casino/supernowa/RNGWorliMatka",
    //   code: "VWM",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: pageUrlGenerator("/Casino"),
    //   imgUrl: "./images/supernowa/RNGWorliMatka.jpg",
    //   alt: "",
    //   name: "RNG Worli Matka",
    //   providerName: "Supernowa",
    // },
    // },
    name: "Supernowa",
  },
  // Vivo: {
  //   slide1: {
  //     CoffeeWild: {
  //       redirectUrl: "/casino/vivo-dragon-tiger",
  //       imgUrl: "./images/Vivo/DragonTiger.jpg",
  //       name: "Dragon Tiger",
  //       providerName: "Vivo",
  //     },
  //     EuropeanAutoRoulette: {
  //       redirectUrl: "/casino/vivo-european-auto-roulette",
  //       imgUrl: "./images/Vivo/EuropeanAutoRoulette.jpg",
  //       name: "European Auto Roulette",
  //       providerName: "Vivo",
  //     },
  //     FrenchRoulette: {
  //       redirectUrl: "/casino/vivo-french-roulette",
  //       imgUrl: "./images/Vivo/FrenchRoulette.jpg",
  //       name: "French Roulette",
  //       providerName: "Vivo",
  //     },
  //     GalaxyBaccarat1: {
  //       redirectUrl: "/casino/vivo-galaxy-baccarat-1",
  //       imgUrl: "./images/Vivo/GalaxyBaccarat1.jpg",
  //       name: "Galaxy Baccarat1",
  //       providerName: "Vivo",
  //     },
  //     GalaxyBaccarat2: {
  //       redirectUrl: "/casino/vivo-galaxy-baccarat-2",
  //       imgUrl: "./images/Vivo/GalaxyBaccarat2.jpg",
  //       name: "Galaxy Baccarat 2",
  //       providerName: "Vivo",
  //     },
  //     GalaxyBaccarat3: {
  //       redirectUrl: "/casino/vivo-galaxy-baccarat-3",
  //       imgUrl: "./images/Vivo/GalaxyBaccarat3.jpg",
  //       name: "Galaxy Baccarat 3",
  //       providerName: "Vivo",
  //     },
  //     GalaxyRoulette: {
  //       redirectUrl: "/casino/vivo-galaxy-roulette",
  //       imgUrl: "./images/Vivo/GalaxyRoulette.jpg",
  //       name: "Galaxy Roulette",
  //       providerName: "Vivo",
  //     },
  //     MacauBaccarat: {
  //       redirectUrl: "/casino/vivo-macau-baccarat",
  //       imgUrl: "./images/Vivo/MacauBaccarat.jpg",
  //       name: "Macau Baccarat",
  //       providerName: "Vivo",
  //     },
  //     Oracle360Roulette: {
  //       redirectUrl: "/casino/vivo-oracle-360-roulette",
  //       imgUrl: "./images/Vivo/Oracle360Roulette.jpg",
  //       name: "Oracle 360 Roulette",
  //       providerName: "Vivo",
  //     },
  //     OracleBlazeRoulette: {
  //       redirectUrl: "/casino/vivo-oracle-blaze-roulette",
  //       imgUrl: "./images/Vivo/OracleBlazeRoulette.jpg",
  //       name: "Oracle Blaze Roulette",
  //       providerName: "Vivo",
  //     },
  //     PortomasoRoulette: {
  //       redirectUrl: "/casino/vivo-portomaso-roulette",
  //       imgUrl: "./images/Vivo/PortomasoRoulette.jpg",
  //       name: "Portomaso Roulette",
  //       providerName: "Vivo",
  //     },
  //     TeenPatti: {
  //       redirectUrl: "/casino/vivo-teen-patti",
  //       imgUrl: "./images/Vivo/TeenPatti.jpg",
  //       name: "Teen Patti",
  //       providerName: "Vivo",
  //     },
  //   },
  //   // slide2: {
  //   //   VABacarat1: {
  //   //     redirectUrl: "/casino/vivo-va-bacarat-1",
  //   //     imgUrl: "./images/Vivo/VABacarat1.jpg",
  //   //     name: "VA Bacarat 1",
  //   //     providerName: "Vivo",
  //   //   },
  //   //   VABacarat2: {
  //   //     redirectUrl: "/casino/vivo-va-bacarat-2",
  //   //     imgUrl: "./images/Vivo/VABacarat2.jpg",
  //   //     name: "VA Bacarat 2",
  //   //     providerName: "Vivo",
  //   //   },
  //   //   VABacarat3: {
  //   //     redirectUrl: "/casino/vivo-va-bacarat-3",
  //   //     imgUrl: "./images/Vivo/VABacarat3.jpg",
  //   //     name: "VA Bacarat 3",
  //   //     providerName: "Vivo",
  //   //   },
  //   //   VABacarat4: {
  //   //     redirectUrl: "/casino/vivo-va-bacarat-4",
  //   //     imgUrl: "./images/Vivo/VABacarat4.jpg",
  //   //     name: "VA Bacarat 4",
  //   //     providerName: "Vivo",
  //   //   },
  //   //   VABacarat5: {
  //   //     redirectUrl: "/casino/vivo-va-bacarat-5",
  //   //     imgUrl: "./images/Vivo/VABacarat5.jpg",
  //   //     name: "VA Bacarat 5",
  //   //     providerName: "Vivo",
  //   //   },
  //   // },
  //   name: "Vivo",
  // },
 
  TvShows: {
    slide1: {
     
    },
    name: "TV Games",
  },
  AllGames: {
    slide1: {
      SpeedRoulette: {
        redirectUrl: "/casino/aggapezugi-speed-roulette",
        code: "1000104",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/speed-roulette-evolution.jpg",
        alt: "",
        name: "Speed Roulette",
        providerName: "Evolution",
      },
      DiamondRoulette: {
        redirectUrl: "/casino/aggapezugi-diamond-roulette",
        code: "221003",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/DiamondRoulette.jpg",
        alt: "",
        name: "Diamond Roulette",
        providerName: "Ezugi",
      },
      NamasteRoulette: {
        redirectUrl: "/casino/aggapezugi-namaste-roulette",
        code: "221005",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Namasteroulette.jpg",
        alt: "",
        name: "Namaste Roulette",
        providerName: "Ezugi",
      },
      AutoRoulette: {
        redirectUrl: "/casino/aggapezugi-automatic-roulette",
        code: "5001",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/AutoRoulette.jpg",
        alt: "",
        name: "Auto Roulette",
        providerName: "Ezugi",
      },
      SpeedAutoRoulette: {
        redirectUrl: "/casino/aggapezugi-speed-auto-roulette",
        code: "1000103",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Speedautoroulleteevo.jpg",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Evolution",
      },
    
    },
    slide2: {
   
      PrestigeAutoRoulette: {
        redirectUrl: "/casino/aggapezugi-prestige-auto-roulette",
        code: "221004",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Prestige-Auto-Roulette.jpg",
        alt: "",
        name: "Prestige Auto Roulette",
        providerName: "Ezugi",
      },
      
    },
    slide3: {
      Baccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat",
        code: "100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat08.jpg",
        alt: "",
        name: "Baccarart",
        providerName: "Ezugi",
      },
      
      Knockoutbaccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat-knockout",
        code: "120",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat03.jpg",
        alt: "",
        name: "Knock Out Baccarart",
        providerName: "Ezugi",
      },
      Super6baccarat: {
        redirectUrl: "/casino/aggapezugi-baccarat-super-six",
        code: "130",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat04.jpg",
        alt: "",
        name: "Super 6 Baccarart",
        providerName: "Ezugi",
      },
      Marinabaccarat: {
        redirectUrl: "/casino/aggapezugi-marina-casino-baccarat-1",
        code: "32100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat05.jpg",
        alt: "",
        name: "Casino Marina Baccarart 1",
        providerName: "Ezugi",
      },

      Marina02baccarat: {
        redirectUrl: "/casino/aggapezugi-marina-casino-baccarat-2",
        code: "32101",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat06.jpg",
        alt: "",
        name: "Casino Marina Baccarart 2",
        providerName: "Ezugi",
      },
     
    },
    slide4: {
      
    },
    slide5: {
      Blackjack: {
        redirectUrl: "/casino/aggapezugi-vip-blackjack",
        code: "201",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Blackjack01.jpg",
        alt: "",
        name: "Blackjack",
        providerName: "Ezugi",
      },

    },
    slide6: {
      
    },
    slide7: {
      
    },
    slide8: {
      aviator: {
        redirectUrl: "/casino/aggapspribe-aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/aviator.gif",
        alt: "",
        name: "Aviator",
        providerName: "Spribe",
      },
      mines: {
        redirectUrl: "/casino/aggapspribe-mines",
        code: "mines",
        casino: "spribe",
        provider: "mines",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Mines.jpg",
        alt: "",
        name: "Mines",
        providerName: "Spribe",
      },
      goal: {
        redirectUrl: "/casino/aggapspribe-goal",
        code: "goal",
        casino: "spribe",
        provider: "goal",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Goal.jpg",
        alt: "",
        name: "Goal",
        providerName: "Spribe",
      },
      dice: {
        redirectUrl: "/casino/aggapspribe-dice",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Dice.jpg",
        alt: "",
        name: "Dice",
        providerName: "Spribe",
      },
      plinko: {
        redirectUrl: "/casino/aggapspribe-plinko",
        code: "plinko",
        casino: "spribe",
        provider: "plinko",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Plinko.jpg",
        alt: "",
        name: "Plinko",
        providerName: "Spribe",
      },
      miniroulette: {
        redirectUrl: "/casino/aggapspribe-mini-roulette",
        code: "mini-roulette",
        casino: "spribe",
        provider: "mini-roulette",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/Mini-roulette.jpg",
        alt: "",
        name: "Mini Roulette",
        providerName: "Spribe",
      },
      hilo: {
        redirectUrl: "/casino/aggapspribe-hilo",
        code: "hi-lo",
        casino: "spribe",
        provider: "hi-lo",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/spribe/HIlo.jpg",
        alt: "",
        name: "Hilo",
        providerName: "Spribe",
      },
    },
    slide9: {
      
    },
    name: "All Games",
  },
  

  Gamelobby: {
    slide1: {
      ezugi: {
        redirectUrl: "/casino/aggapezugi-ezugi-lobby",
        code: "",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/providers/slotspage/ezugi.gif",
        alt: "",
        name: "Ezugi",
        providerName: "Ezugi",
      },
      evolution: {
        redirectUrl: "/casino/evolution",
        code: "",
        casino: "ezugi",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/providers/slotspage/Evolution.png",
        alt: "",
        name: "Evolution",
        providerName: "Evolution",
      },
      supernowa: {
        redirectUrl: "/casino/supernowa",
        code: "",
        casino: "wco",
        provider: "SN",
        homeUrl: "",
        imgUrl: "./images/providers/slotspage/Supernowa.png",
        alt: "",
        games: {},
        name: "Supernowa",
        providerName: "Supernowa",
      },
      worldcasino: {
        redirectUrl: "/casino/worldcasino",
        code: "",
        casino: "wco",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/providers/slotspage/WorldCasino.png",
        alt: "",
        games: {},
        name: "World Casino",
        providerName: "World Casino",
      },
      xpg: {
        redirectUrl: "/casino/xpg",
        code: "",
        casino: "wco",
        provider: "XPG",
        homeUrl: "",
        imgUrl: "./images/providers/slotspage/XPG.jpg",
        alt: "",
        games: {},
        name: "XPG",
        providerName: "XPG",
      },
      // onetouch: {
      //   redirectUrl: "/casino/onetouch",
      //   code: "",
      //   casino: "wco",
      //   provider: "OT",
      //   homeUrl: "",
      //   cover: { src: "./images/providers/new/OneTouch.png", alt: "" },
      //   imgUrl: "./images/providers/slotspage/OneTouch.jpg",
      //   alt: "",
      //   games: {},
      //   name: "One Touch",
      //   providerName: "One Touch",
      // },
      // onlyplay: {
      //   redirectUrl: "/casino/onlyplay",
      //   code: "",
      //   casino: "wco",
      //   provider: "GT",
      //   homeUrl: "",
      //   imgUrl: "./images/providers/slotspage/OnlyPlay.png",
      //   alt: "",
      //   games: {},
      //   name: "Only Play",
      //   providerName: "Only Play",
      // },
      // pragmaticplay: {
      //   redirectUrl: "/casino/pragmaticplay",
      //   code: "",
      //   casino: "wco",
      //   provider: "PP",
      //   homeUrl: "",
      //   imgUrl: "./images/providers/slotspage/Pragamatic.png",
      //   alt: "",
      //   games: {},
      //   name: "Pragmatic Play",
      //   providerName: "Pragmatic Play",
      // },

      vivo: {
        redirectUrl: "/casino/vivo",
        code: "vivo",
        casino: "vivo",
        provider: "",
        homeUrl: "",
        imgUrl: "./images/providers/slotspage/Vivo.jpg",
        name: "Vivo Gaming",
        providerName: "Vivo",
      },
    },
    name: "Game Lobby",
  },
};
